@let loading = loadingSg();
@let error = errorSg();
<atn-ds-centered-overlay
  (backdropClick)="cancel.emit()"
  type="confirmation"
>
  <div
    class="ds-confirmation-overlay"
    data-test-id="confirmation-dialog"
  >
    <div class="ds-confirmation-overlay__header">
      <div class="ds-confirmation-overlay__title">
        {{ titleSg() }}
      </div>
      <div
        class="ds-confirmation-overlay__header-cross-btn"
        (click)="cancel.emit()"
      >
        <i class="atn-icon atn-close atn-red"></i>
      </div>
    </div>
    <div class="ds-confirmation-overlay__body">
      <div [innerHTML]="descriptionSg()"></div>
      <ng-content select="[details]" />
      @if (validationTextSg()) {
        <atn-ds-text
          [placeholder]="validationTextSg()"
          [value]="validationInputSg()"
          (change)="validationInputSg.set($event)"
        ></atn-ds-text>
      }
      @if (error) {
        <div class="ds-confirmation-overlay__error">
          {{ error }}
        </div>
      }
    </div>
    <div class="ds-confirmation-overlay__footer">
      <atn-ds-button
        class="ds-confirmation-overlay__footer-btn"
        data-test-id="cancelButton"
        [type]="cancelButtonStyleSg()"
        (click)="cancel.emit()"
        >{{ cancelButtonTextSg() }}</atn-ds-button
      >
      <atn-ds-button
        class="ds-confirmation-overlay__footer-btn"
        [disabled]="!canConfirmSg()"
        [type]="confirmButtonStyleSg()"
        (click)="!loading && confirmClickHandler()"
        [loading]="loading"
        >{{ confirmButtonTextSg() }}</atn-ds-button
      >
    </div>
  </div>
</atn-ds-centered-overlay>
